import client from "../graphqlClient";
import {ADD_PRODUCT_REVIEW, GET_USER_REVIEWS, GET_USER_REVIEWS_DETAIL} from "../gql/reviews/reviews.gql"
export let userReviews = async (variables) => {
  let options = {
    query: GET_USER_REVIEWS,
    variables: variables,
    context: {
      headers: {
        Authorization: `Bearer ${variables.token}`,
      }
  }
  };

  try {
    let response = await client.query(options);
    return response;
  } catch (error) {
    return error
  }
};
export let addProductReview = async (variables) => {
  let options = {
    mutation: ADD_PRODUCT_REVIEW,
    variables: variables,
  };
  if(variables?.token){
    options = {
      ...options, context: {
        headers: {
          Authorization: `Bearer ${variables.token}`,
        }
    },
    }
  }

  try {
    let response = await client.mutate(options);
    return response;
  } catch (error) {
    return error
  }
};
export let userReviewDetail = async (variables) => {
  let options = {
    query: GET_USER_REVIEWS_DETAIL,
    variables: variables,
    context: {
      headers: {
        Authorization: `Bearer ${variables.token}`,
      }
  }
  };
  try {
    let response = await client.query(options);
    return response;
  } catch (error) {
    return error
  }
};